import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { Orgao } from 'src/app/shared/models/orgao.model';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { ModalResponsavelComponent } from '../../modal-responsavel/modal-responsavel.component';
import { ProjetoList } from '../../models/projeto-list.model';
import { NavigationService } from '../../services/navigation.service';
import { ProgramaService } from '../../services/programa.service';
import { ProjetoAgregadorService } from '../../services/projeto-agregador.service';

@Component({
  selector: 'app-pesquisa-programa',
  templateUrl: './pesquisa-programa.component.html',
  styleUrls: ['./pesquisa-programa.component.scss'],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(-50%)' }),
        animate('500ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0, transform: 'translateX(-50%)' }))
      ])
    ])
  ]
})
export class PesquisaProgramaComponent extends BaseListComponent<any> implements OnInit {

  form: FormGroup;
  orgaoList: Orgao[];
  listFilters: any;
  lista: any[];
  listaPesquisa: any[];
  filter_pesquisa: string = "";
  projetoList: ProjetoList[];
  programaList: any[];
  agregadorList: any[];
  eixoList: any[];
  advancedSearchActive: boolean;
  labelAdvancedSearch: string = "Pesquisa Avançada";
  canCreate: boolean = false;
  filterActive: boolean = false;
  simNaoList: any[] = [
    { id: "0", label: "Não" },
    { id: "1", label: "Sim" },
  ];

  @ViewChild("modalResonsavel") modalResonsavel: ModalResponsavelComponent;

  constructor(
    public activatedRoute: ActivatedRoute,
    public pesquisaService: ProgramaService,
    public projetoAgregadorService: ProjetoAgregadorService,
    private navigation: NavigationService
  ) {
    super();
  }

  ngOnInit() {
    this.orgaoList = this.activatedRoute.snapshot.data["listOrgao"];
    this.initForm();
    this.search();
  }

  initForm() {
    this.form = new FormGroup({
      filter_agency: new FormControl(null),
      filter_agency_pg_type1: new FormControl(null),
      filter_agency_pg_type2: new FormControl(null),
      filter_pg_type1: new FormControl(null),
      filter_pg_type2: new FormControl(null),
      filter_axis: new FormControl(null),
      filter_op_status_id: new FormControl(null),
      filter_objective: new FormControl(null),
      filter_with_warn: new FormControl(null),
      filter_actived: new FormControl("1"),
      filter_irfe_enabled_id: new FormControl(null),
      filter_level_priority: new FormControl(null),
      filter_ircp_enabled_id: new FormControl(null),
      filter_pesquisa: new FormControl(null),
    })
  }

  cleanSearch() {
    this.form.reset();
  }

  advancedSearch() {
    this.filterActive = true;
    if (!this.listFilters) {
      this.loading();
      this.projetoAgregadorService.listFilters().subscribe({
        next: (res) => {
          this.listFilters = res;
          this.programaList = this.listFilters.programa;
          this.agregadorList = this.listFilters.agregador;
          this.loaded();
        },
      })
    }
  }

  pesquisar() {
    this.listaPesquisa = this.lista.filter(item => item['title'].toLowerCase().includes(this.filter_pesquisa.toLowerCase()));
  }

  getDataCreate() {
    let data: any;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  search() {
    this.loading();
    this.addSub(
      this.pesquisaService.getListSearchProjetos(this.getDataCreate()).subscribe({
        next: (res) => {
          this.lista = res['list'];
          this.listaPesquisa = this.lista;
          this.canCreate = res['canCreate'];
          EventSharedService.get('atualizaProjetos').emit(res);
          this.loaded();
        },
      })
    );
  }

  closeFilter() {
    if (this.filterActive) {
      this.filterActive = false;
    }
  }

  editarClickHandler(data: any) {
    return ['/projetos', 'programa', data.id];
  }

  novo() {
    return ['/projetos', 'programa', 'adicionar'];
  }

  viewResonsavel(programa: any) {
    this.modalResonsavel.openModal([programa, ...programa?.manager_adjunct]);
  }

}
